import { makeStyles } from '@material-ui/styles';
import React from 'react';

import PatientDocumentLink from 'src/components/general/patientDocumentLink';
import useTypedSWR from 'src/components/general/useTypedSWR';
import { GET_CHART_PROPERTIES } from 'src/components/pages/pageElements/tasks/getTaskChartProperties.gql';
import { PatientTask } from 'src/components/pages/pageElements/tasks/getTasks.gql';

type PatientTaskResultsProps = {
  patientId: string;
  taskId: string;
  flowName?: string;
  rowData: PatientTask;
};

export const PatientTaskResults = ({
  patientId,
  taskId,
  flowName = '',
  rowData,
}: PatientTaskResultsProps) => {
  const styles = useStyles();

  const { data: { interactionChartProperties } = { interactionChartProperties: [] } } = useTypedSWR(
    [GET_CHART_PROPERTIES, { patientId, taskId }],
  );

  // Tasks with flow name idCardUpload or insuranceCardUpload do not
  // generate CPVs. They generate file uploads that will appear in the
  // patient's document tab
  const showDocumentLink = flowName.includes('CardUpload');

  return (
    <div className={styles.container}>
      {showDocumentLink ? (
        <PatientDocumentLink>Patient Documents</PatientDocumentLink>
      ) : (
        <ul>
          {interactionChartProperties.map(cpv => {
            const propertyLabelsByName = rowData.flow.elements.reduce((props, element) => {
              const elementLabelsByName = (element.properties || []).reduce(
                (labelsByName, prop) => ({ ...labelsByName, [prop.name]: prop.label }),
                {},
              );
              return { ...props, ...elementLabelsByName };
            }, {});
            return (
              <li key={`${taskId}:${cpv.propertyName}`}>
                {`${propertyLabelsByName[cpv.propertyName] || cpv.propertyName}: ${cpv.value}`}
              </li>
            );
          })}
        </ul>
      )}
    </div>
  );
};

const useStyles = makeStyles({
  container: {
    padding: '8px 16px',
  },
});
